/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BulkRejectItemResult } from './bulkRejectItemResult';

export interface BulkRejectResponse {
  results: BulkRejectItemResult[];
  rejected?: number;
  archived_local?: number;
  failed?: number;
  resolved_count?: number;
  truncated?: boolean;
}
